<template>
    <v-container class="ma-0 pa-0 steps_container" fill-height>
		<v-row dense class="ma-0 pa-0 px-7">
			<v-col cols="12" align-self="start" class="steps_title_descript mb-8">
				<p class="steps_count">8/8</p>
                <span class="steps_bolder_words">부모, 형제, 자매</span>중<br/>
                다음 질환을 앓았거나 해당 질환으로<br>
                사망한 경우가 있으신가요? <br/>
                <span class="sub-style2">* 복수 선택 가능</span>
			</v-col>
            <v-col cols="12" align-self="center" align="left">
                <ul role="listbox">
                    <li
                        tabindex="1"
                        role="listitem"
                        :class="isSelected('none') ? 'selected' : ''"
                        @click="OnClickItem('none')"
                        @keydown.enter="OnClickItem('none')"
                    >
                        해당없음
                    </li>
                    <li
                        tabindex="2"
                        role="listitem"
                        :class="isSelected('stroke') ? 'selected' : ''"
                        @click="OnClickItem('stroke')"
                        @keydown.enter="OnClickItem('stroke')"
                    >
                        뇌졸중(중풍)
                    </li>
                    <li
                        tabindex="3"
                        role="listitem"
                        :class="isSelected('hprts') ? 'selected' : ''"
                        @click="OnClickItem('hprts')"
                        @keydown.enter="OnClickItem('hprts')"
                    >
                        고혈압
                    </li>
                    <li
                        tabindex="4"
                        role="listitem"
                        :class="isSelected('diabml') ? 'selected' : ''"
                        @click="OnClickItem('diabml')"
                        @keydown.enter="OnClickItem('diabml')"
                    >
                        당뇨병
                    </li>
                    <li
                        tabindex="5"
                        role="listitem"
                        :class="isSelected('heart') ? 'selected' : ''"
                        @click="OnClickItem('heart')"
                        @keydown.enter="OnClickItem('heart')"
                    >
                        심장병(심근경색/협심증)
                    </li>
                    <li
                        tabindex="6"
                        role="listitem"
                        :class="isSelected('cancer') ? 'selected' : ''"
                        @click="OnClickItem('cancer')"
                        @keydown.enter="OnClickItem('cancer')"
                    >
                        기타 암
                    </li>
                </ul>
            </v-col>
            <v-toast ref="toast" />
		</v-row>

        <v-row dense class="ma-0 pa-0 py-4">
			<v-col cols="12" align-self="center" align="center" class="pa-0 ma-0"></v-col>
		</v-row>

        <v-container class="pa-0 ma-0 mt-5 footer_btn_group">
			<v-row class="ma-0 pa-0">
				<v-col cols="3" class="ma-0 pa-0">
					<v-btn
						elevation="0"
						class="tearms_cancel_btn"
						block
						tabindex="8"
						@click="previous"
						tile
						v-ripple
					>
						이전
					</v-btn>
				</v-col>
				<v-col cols="9" class="ma-0 pa-0">
                    <v-btn
						elevation="0"
						block
						:class="this.enableButton ? 'tearms_start_enable_btn' : 'tearms_start_disable_btn'"
						tabindex="9"
						@click="next"
						tile
						v-ripple
					>
						건강 정보 분석 하기
					</v-btn>
				</v-col>
			</v-row>
        </v-container>
    </v-container>
</template>

<script>
	import { mapActions, mapGetters } from "vuex"
    import moment from "moment"
    import VToast from "@/components/popup/toast.vue"
	export default {
        components: {
            VToast
        },
		data: () => ({
			enableButton: true,
            selectedList: [],
            toastMsg: ''
		}),
		computed: {
			...mapGetters("user", [
                "getUser",
			]),
			...mapGetters("survey", [
                "checkUp",
                "checkupNo"
			])
		},
		methods: {
			...mapActions('survey', [
				'setCheckupTemp',
				'setStep',
                'requestCheckup',
                'requestCheckupAgain',
                'setCheckupNo'
			]),
			isSelected(item) {
				if(item === 'none') {
					if(this.selectedList.length <= 0) {
						return true
					}
				}
				else {
					const index = this.selectedList.indexOf(item)
					if(index > -1) {
						return true
					}
				}
				return false
			},
			OnClickItem(item) {
				if(item === 'none') {
					this.selectedList = []
				}
				else {
					const index = this.selectedList.indexOf(item)
					if(index > -1) {
						this.selectedList.splice(index, 1)
					}
					else {
						this.selectedList.push(item)
					}
				}
			},
			previous() {
				this.setStep(10)
				this.$router.push("/checkup/step10");
			},
			async next() {
                this.enableButton = false
                {
                    this.$refs.toast.open('건강 정보 분석 중입니다...', false)
                    const fcCode = this.$store.getters['user/fcCode']

                    let diseaseList = this.selectedList.join(',')
                    const params = {
                        step: 11,
                        fmly: diseaseList,
                        empCode: this.getUser.managerCode
                    };
                    this.setCheckupTemp(params)
                    const additional = {
                        name: this.getUser.name,
                        birthday: this.getUser.birthday,
                        gender: this.getUser.gender,
                        checkupDate: moment().format('YYYYMMDD'),
                        role: 'RM'
                    }

                    const survey = Object.assign(this.checkUp, additional)
                    survey.fcCode = fcCode

                    const param = {
                        authToken : this.getUser.authToken,
                        checkupNo : this.checkupNo,
                        survey,
                        fcCode
                    }

                    let res = await this.requestCheckup(param)
                    let resultCode = Number(res.data.code)
                    if(resultCode === 422) {    // Duplicated Checkup, so try again with modify api
                        res = await this.requestCheckupAgain(param)
                        resultCode = Number(res.data.code)
                    }
                    this.$refs.toast.close()
                    if(resultCode === 200) {
                        this.setCheckupNo(res.data.result.checkupNo)
                        this.setStep(0)
                        this.$router.push("/checkup/reportOverview")
                    }
                    else if(resultCode === 401) {
                        this.$refs.toast.open(this.$t('error.common.unauthorized'))
                    }
                    else if(resultCode === 500) {
                        this.$refs.toast.open(this.$t('error.common.internalServer'))
                    } else if (resultCode === 406) {
                        console.log('Prediction Error', res.code, res.error, res.message)
                        this.$refs.toast.open(this.$t('error.common.badParam', {error: resultCode}))
                    } else if (resultCode === 407) {
                        console.log('Prediction Error', res.code, res.error, res.message)
                        this.$refs.toast.open(this.$t('error.common.noDisease', {error: resultCode}))
                    } else {
                        console.log('Prediction Error', res.code, res.error, res.message)
                        this.$refs.toast.open(this.$t('error.common.unknown', {error: resultCode}))
                    }
                }
                this.enableButton = true
			},
			restoreData() {
				if(this.checkUp.fmly) {
					this.selectedList = this.checkUp.fmly.split(',')
				}
			}
		},
		mounted() {
            window.scrollTo(0, 0)
			this.setStep(11)
			this.restoreData()
		}
	};
</script>

<style scoped>
    .sub-style2 {
		font-family: "NanumSquare", sans-serif;
		font-weight: 700;

		font-size: 14px;
		letter-spacing: -0.35px;
		color: #202020;
		opacity: 0.5;
	}
    .title {
        min-height: 30vh;
    }
	ul li {
		display: inline-block;
		background-color: #f3f3f5;
		color: #809bb2;
		font-size: 1.05em;
		padding: 0 15px;
		margin: 0 0.4vh 0.8vh 0;
		height: 5vh;/*45px;*/
		line-height: 5vh;
		vertical-align: middle;
		border-radius: 2.5vh;
        font-weight: 500;
        transition: background-color 300ms, color 450ms, font-weight 600ms;
	}
    ul li.selected {
        background-color: #3f6fff;
        color: white;
        font-weight: bold;
        outline: none;
    }

    ul li:focus-visible {
        outline: #1e1e1e solid 3px;
    }

	.tearms_cancel_btn {
		height: 60px !important;
		background-color: #dcdfe6 !important;
		color: #193263;
		font-weight: 700;
        font-family: NanumSquare, sans-serif !important;
	}

	.tearms_start_enable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif;
        color: white !important;
		border: 0;
		outline: none;
	}

	.tearms_start_disable_btn {
		height: 60px !important;
		background-color: #193263 !important;
        font-family: NanumSquare, sans-serif !important;
        color: white !important;
		border: 0;
		outline: none;
    }

	::v-deep .tearms_start_disable_btn .v-btn__content {
		color: white !important;
	}

	::v-deep .tearms_start_enable_btn .v-btn__content {
		color: white !important;
	}

	.terms_container {
		word-break: keep-all;
        align-items: baseline !important;
    }

	@media screen and (max-height: 759px)
    {   
        .intro_title_img{
            margin-top:0;
        }
    }
</style>
